import { render, staticRenderFns } from "./fccTipoPublicacao.vue?vue&type=template&id=692df097"
import script from "./fccTipoPublicacao.vue?vue&type=script&lang=js"
export * from "./fccTipoPublicacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports